import env from "@/env"
import { CSSProperties } from "react"
import { RiskFamily, RISK_FAMILY_UNDEFINED_ID } from "./risk-family.types"
import riskFamilyTemplatesJson from "./risk-family.template.json"

//Banque IDTree : familles modeles, proposees a l'ajout ; leur code donne leur image
export type RiskFamilyTemplate = Pick<RiskFamily, "code" | "name">
export const RISK_FAMILY_TEMPLATES = riskFamilyTemplatesJson as RiskFamilyTemplate[]

//Rendering of the family image inside a CardButton (mosaic + wizard)
export const RISK_FAMILY_IMAGE_STYLE: CSSProperties = {
  height: 44,
  maxWidth: "100%",
  objectFit: "contain",
  width: "auto"
}

/** Onglet des familles (l'id de famille s'y ajoute pour le detail).
 *  Chemin relatif a l'espace risques : a passer a getPath (cf. useRisksSpace). */
export const RISK_FAMILIES_PATH = "/phy"

/** Garde les familles auxquelles au moins un risque est rattache, y compris la famille « Non défini ». */
export function filterRiskFamiliesWithRisks<T extends { id: string }>(
  families: T[],
  risks: Array<{ RiskFamilyId: string | null }>
) {
  const familyIdsWithRisks = new Set(risks.map((risk) => risk.RiskFamilyId ?? RISK_FAMILY_UNDEFINED_ID))
  return families.filter((family) => familyIdsWithRisks.has(family.id))
}

export function getRiskFamilyImageUrl(family: RiskFamily) {
  if (family.id === RISK_FAMILY_UNDEFINED_ID) return null

  const imageId = family.isImageCustom ? family.id : family.code
  if (!imageId) return null

  return env.REACT_APP_URL_SPACE.concat("/RiskFamilies/", imageId, ".png")
}

// Compatibilité avec les bases historiques où RiskFamilies.code est limité à 30 caractères.
const RISK_FAMILY_CODE_MAX_LENGTH = 30

/** Code court et unique ; le nom complet de la famille est conservé séparément. */
export function createCodeFromName(name: string, existingCodes: Set<string>) {
  const baseCode =
    name
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .toUpperCase() || "CUSTOM"

  let code = baseCode.slice(0, RISK_FAMILY_CODE_MAX_LENGTH)
  let index = 2
  while (existingCodes.has(code)) {
    const suffix = `_${index}`
    code = `${baseCode.slice(0, RISK_FAMILY_CODE_MAX_LENGTH - suffix.length)}${suffix}`
    index += 1
  }

  return code
}
